module.exports = __webpack_public_path__ + "img/Edelstahlhandlauf_rathaus.b50a1202.webp";